@if (contentlet()) {
<div class="dot-cms-html-content default-web-page-content-class">
  @if (isInsideEditor) {
  <!-- <custom-dot-editable-text [fieldName]="'body'" [contentlet]="contentlet" [format]="'html'" [mode]="'full'" /> -->
  <dotcms-editable-text [fieldName]="'body'" [contentlet]="contentlet()" [format]="'html'" [mode]="'full'" />
  } @else {
  <div class="dot-cms-html-content default-web-page-content-class" [ishServerHtml]="contentlet().body"></div>
  }
</div>
}
